export function getPusherChannelName(stream, system = null, instance = null) {
  return [system, instance, stream].filter(part => part !== null).join("__");
}
